import * as Svg from '../common/icons';
import React from 'react';
import SidebarStyles from './SideBar.style';
import '../../styles/navs/SideBar.css';
import { NavLink } from 'react-router-dom';
import { List, ListItem, ListItemIcon } from '@material-ui/core';

const ExactNavLink = (props) => <NavLink {...props} />;

const SideBar = () => {
  const classes = SidebarStyles();
  return (
    <div className='sidebar'>
      <List className={classes.menu}>
        <ExactNavLink to={`/`} activeClassName={'active'}>
          <ListItem button>
            <ListItemIcon>
              <Svg.Dashboard></Svg.Dashboard>
            </ListItemIcon>
          </ListItem>
        </ExactNavLink>
        {/* <ExactNavLink to={`/schedule`} activeClassName={'active'}>
          <ListItem button>
            <ListItemIcon>
              <Svg.Schedule></Svg.Schedule>
            </ListItemIcon>
          </ListItem>
        </ExactNavLink> */}
        <ExactNavLink to={`/operations`} activeClassName={'active'}>
          <ListItem button>
            <ListItemIcon>
              <Svg.Operations></Svg.Operations>
            </ListItemIcon>
          </ListItem>
        </ExactNavLink>
        <ExactNavLink to={`/maintenance`} activeClassName={'active'}>
          <ListItem button>
            <ListItemIcon>
              <Svg.Maintenance></Svg.Maintenance>
            </ListItemIcon>
          </ListItem>
        </ExactNavLink>

        <ExactNavLink to={`/housekeeping`} activeClassName={'active'}>
          <ListItem button>
            <ListItemIcon>
              <Svg.HouseKeeping></Svg.HouseKeeping>
            </ListItemIcon>
          </ListItem>
        </ExactNavLink>

        {/* <ExactNavLink to={`/reports`} activeClassName={'active'}>
          <ListItem button>
            <ListItemIcon>
              <Svg.Reports></Svg.Reports>
            </ListItemIcon>
          </ListItem>
        </ExactNavLink> */}
      </List>

      <div className='setting'>
        <List className={classes.menu} style={{ top: '24px' }}>
          <ExactNavLink to={`/manager`} activeClassName={'active'}>
            <ListItem button>
              <ListItemIcon>
                <Svg.Settings></Svg.Settings>
              </ListItemIcon>
            </ListItem>
          </ExactNavLink>
        </List>
      </div>
      <div className='brand-name'>strēmlīnd</div>
    </div>
  );
};

export default SideBar;
